export default function Solutions() {
  const solutions = [
    {
      name: 'Enterprise Solutions',
      value: 'Scalable & Reliable',
      bgColor: 'bg-blue-100',
      buttonStyle: 'bg-gray-900 text-white',
      description: 'For established corporations',
    },
    {
      name: 'SME Solutions',
      value: 'Flexible & Efficient',
      bgColor: 'bg-gray-100',
      buttonStyle: 'bg-white text-gray-900 border-2 border-gray-900',
      description: 'For growing businesses',
    },
    {
      name: 'Startup Solutions',
      value: 'Agile & Innovative',
      bgColor: 'bg-gray-100',
      buttonStyle: 'bg-white text-gray-900 border-2 border-gray-900',
      description: 'For emerging ventures',
    },
  ];

  return (
    <section id="solutions" className="pt-8 pb-14 md:pb-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-5 md:px-6">
        <div className="mb-10 md:mb-16 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-blue-500 bg-transparent mb-4 md:mb-6">
            <i className="ri-layout-grid-line text-blue-600 text-sm"></i>
            <span className="text-blue-600 text-sm font-medium whitespace-nowrap">Solutions</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-6xl font-extralight text-gray-900 mb-3 md:mb-4 leading-tight mt-2 md:mt-4">
            Scalable Solutions for Every Business Need
          </h2>
          <p className="text-sm text-gray-500 font-normal">
            From startups to established enterprises
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-8 mt-6 md:mt-20">
          {solutions.map((solution, index) => {
            const images = [
              "https://readdy.ai/api/search-image?query=large%20modern%20corporate%20office%20building%20exterior%20with%20glass%20facade%2C%20sleek%20architecture%2C%20city%20skyline%20background%2C%20professional%20enterprise%20headquarters%2C%20clean%20minimalist%20style%2C%20soft%20natural%20lighting%2C%20high-end%20business%20district%2C%20architectural%20photography%20aesthetic%2C%20blue%20sky%20with%20subtle%20clouds%2C%20premium%20corporate%20identity&width=400&height=400&seq=sol-enterprise-v2&orientation=squarish",
              "https://readdy.ai/api/search-image?query=small%20business%20team%20collaborating%20in%20bright%20modern%20open%20office%2C%20diverse%20professionals%20working%20together%2C%20whiteboards%20and%20laptops%2C%20warm%20natural%20light%2C%20creative%20workspace%20interior%2C%20productive%20atmosphere%2C%20contemporary%20furniture%2C%20plants%20and%20greenery%2C%20friendly%20SME%20environment%2C%20clean%20minimal%20design&width=400&height=400&seq=sol-sme-v2&orientation=squarish",
              "https://readdy.ai/api/search-image?query=young%20startup%20founders%20brainstorming%20in%20vibrant%20coworking%20space%2C%20sticky%20notes%20on%20glass%20wall%2C%20innovative%20tech%20startup%20atmosphere%2C%20energetic%20and%20creative%20environment%2C%20modern%20industrial%20loft%20style%2C%20exposed%20brick%20and%20concrete%2C%20colorful%20accents%2C%20agile%20team%20culture%2C%20entrepreneurial%20spirit%2C%20bright%20and%20inspiring%20workspace&width=400&height=400&seq=sol-startup-v2&orientation=squarish"
            ];
            return (
              <div key={index} className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-10 shadow-sm hover:shadow-lg transition-shadow">
                <div className={`${solution.bgColor} rounded-xl md:rounded-2xl h-40 sm:h-48 md:h-64 mb-5 md:mb-8 flex items-center justify-center overflow-hidden`}>
                  <img
                    src={images[index]}
                    alt={solution.name}
                    className="w-full h-full object-cover rounded-xl md:rounded-2xl"
                  />
                </div>

                <h3 className="text-base md:text-xl font-medium text-gray-900 text-center mb-1 md:mb-2">
                  {solution.name}
                </h3>

                <p className="text-xl md:text-3xl font-semibold text-gray-900 text-center mb-3 md:mb-6">
                  {solution.value}
                </p>

                <p className="text-xs text-gray-400 text-center">
                  {solution.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}